import { render, staticRenderFns } from "./OrdineSpacchettato.vue?vue&type=template&id=0098b974&scoped=true"
import script from "./OrdineSpacchettato.vue?vue&type=script&lang=ts"
export * from "./OrdineSpacchettato.vue?vue&type=script&lang=ts"
import style0 from "./OrdineSpacchettato.vue?vue&type=style&index=0&id=0098b974&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098b974",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0098b974')) {
      api.createRecord('0098b974', component.options)
    } else {
      api.reload('0098b974', component.options)
    }
    module.hot.accept("./OrdineSpacchettato.vue?vue&type=template&id=0098b974&scoped=true", function () {
      api.rerender('0098b974', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrdineSpacchettato.vue"
export default component.exports